<div class="img" *ngIf="reInit" [formGroup]="group">
    <div class="title">
        <h2 class="padding-10">
            {{ field.label | titlecase }}
        </h2>
    </div>

    <!-- <div style="position: relative; width: 100%;">
        <input #searchInput
            style="width: 100%;height: 50px;margin-bottom: 15px;border: 1px solid #c6c4c4;border-radius: 5px; padding-left: 5px;"
            type="text" placeholder="{{ field.name | titlecase }}" (input)="onSearch($event.target.value)" />
        <mat-icon style="position: absolute;right: 10px;top:40%;transform: translateY(-50%);cursor: pointer;">search
        </mat-icon>
    </div> -->

    <!-- <div fxLayoutAlign="center center" *ngIf="filteredImages.length === 0" style="font-size: 20px;">
        No records found
    </div> -->

    <div class="pointer" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-around center"
        *ngIf="filteredImages.length > 0; else noRecords">
        <div fxLayout="row wrap" fxFlex="100" class="gapbottom">
            <div fxFlex.xs="50" fxFlex="25" *ngFor="let image of filteredImages">
                <img style="width: 100%;" (click)="setValue(image.value, searchInput)" [alt]="field.customfield3"
                    [src]="serverPath + image.image + cid" />
            </div>
        </div>
    </div>

    <ng-template #noRecords>
        <div fxLayout="row" fxLayoutAlign="center center" style="padding: 20px; color: #777;">
            No records found
        </div>
    </ng-template>
</div>